<template>
  <div class="filter">
    <v-breadcrumbs :items="breadcrumbs" />
    <FilterGraph />
  </div>
</template>
<script>
export default {
  name: "Filter",
  components: {
    FilterGraph: () => import('@/components/graph/FilterGraph.vue'),
  },
  computed: {
    breadcrumbs () {
      return [
                  {
                      text: 'Главная',
                      disabled: false,
                      href: '/'
                  },
                  {
                      text: 'Графики',
                      disabled: true
                  }
              ];
    }
  }
}
</script>
<style lang="scss" scoped>
  .filter {
    min-height: 60vh;
    background: #fff;
    padding: 45px 35px 10px;
    -webkit-box-shadow: 0 0 15px 0 rgb(0 0 0 / 20%);
    box-shadow: 0 0 15px 0 rgb(0 0 0 / 20%);

    @media (max-width: 500px) {
        padding: 20px 20px;
    }

    @media (max-width: 340px) {
        padding: 0px 0px;
    }
  }
</style>